/**
 * Class-name merge for the `src/ui` primitives.
 *
 * `twMerge` must know the token names the theme adds, or it misreads them: `text-h2`
 * is a font size, not a colour, and `rounded-control` is a radius. Without these
 * extensions `text-ink text-h2` would silently drop the colour.
 */
import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [{ text: ["h1", "h2"] }],
      rounded: [{ rounded: ["small", "control", "card", "pill"] }],
      shadow: [{ shadow: ["overlay"] }],
    },
  },
});

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
